import React from 'react';
import { useUserSettingsContext } from 'users/utils/contexts/UserSettingsContext';
import { CustomTooltipProps } from './types.ts';
import styles from './sankeyChart.module.scss';

const CustomTooltip: React.FC<CustomTooltipProps> = ({ active, payload, fullData, overrideCurrency }) => {
  const { getCurrencyNumber } = useUserSettingsContext();

  if (active && payload?.length) {
    const { source, target, value, totalTargetValue } = payload[0]?.payload?.payload ?? {};

    if (!source && !target) return;
    if (target?.sourceNodes?.length && target?.sourceNodes?.length > 1) {
      const targetNodeIndex = fullData.nodes.findIndex((node) => node.id === target.id);
      return (
        <div className={styles.tooltip}>
          <div className={styles.header}>
            <span>{target?.name}:</span>
            <span>{getCurrencyNumber(totalTargetValue ?? 0, null, {}, overrideCurrency)}</span>
          </div>
          <div className={styles.content}>
            {target?.sourceNodes?.map((nodeIndex: number) => {
              const nodeData = fullData.nodes[nodeIndex];
              const linkData = fullData.links.find(
                (link) => link.source === nodeIndex && link.target === targetNodeIndex,
              );
              const percentage = totalTargetValue && linkData?.value ? (linkData.value / totalTargetValue) * 100 : null;
              return (
                <div key={nodeIndex} className={styles.tooltipRow}>
                  <span className={styles.name}>{nodeData.name}:</span>
                  <span>{`${getCurrencyNumber(linkData?.value ?? 0, null, {}, overrideCurrency)} (${
                    percentage ? percentage.toFixed(2) : 0
                  }%)`}</span>
                </div>
              );
            })}
            {fullData.nodes[targetNodeIndex]?.negativeLinks?.map((negativeLink) => {
              const nodeData = fullData.nodes[negativeLink.source];
              const percentage =
                totalTargetValue && negativeLink?.value ? (negativeLink.value / totalTargetValue) * 100 : null;
              return (
                <div key={`${negativeLink.source}=${negativeLink.target}`} className={styles.tooltipRow}>
                  <span className={styles.name}>{nodeData.name}:</span>
                  <span>{`${getCurrencyNumber(negativeLink?.value ?? 0, null, {}, overrideCurrency)} (${
                    percentage ? percentage.toFixed(2) : 0
                  }%)`}</span>
                </div>
              );
            })}
          </div>
        </div>
      );
    }
    return (
      <div className={styles.tooltip}>
        <div className={styles.content}>
          <div className={styles.tooltipRow}>
            <span className={styles.name}>{target?.name}:</span>
            <span>{getCurrencyNumber(value, null, {}, overrideCurrency)}</span>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default CustomTooltip;
